import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

const HelmetScript = (props) => {
  const { jsScript = '', i18n, extraHead = '', helmetScriptCallBack = null } = props;

  const curLang = i18n.locale;

  const [jsScriptTimeout, setJsScriptTimeout] = React.useState('');

  useEffect(() => {
    const timeout = extraHead ? 200 : 0;
    setJsScriptTimeout('');
    setTimeout(() => {
      setJsScriptTimeout(jsScript);
    }, timeout);
  }, [jsScript, curLang]);

  const onChangeClientState = (state) => {
    const isReady = state.scriptTags.findIndex((tag) => tag.name === 'customJsScript') !== -1;
    helmetScriptCallBack(isReady);
  };

  return (
    <Helmet onChangeClientState={onChangeClientState}>
      {jsScriptTimeout && <script name="customJsScript">{jsScriptTimeout}</script>}
    </Helmet>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(HelmetScript);

export { HelmetScript as HelmetScriptComponent }; // <- For component Unit Test
export default connectStore;
